export default "__VITE_ASSET__DEJQw3cm__"